import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { SharingService } from './services/share.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,HeaderComponent,FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'roundtablecxo';
  constructor(private svc: SharingService) {
    let origin = window.location.origin;

    let hostname = window.location.hostname;

    let url: string;
    if (origin.includes('localhost')) {
      // Have only one thing and change during development.
      url = "https://dev.roundtablecxo.com/events-api/api/"
      // For local development testing
      this.svc.getbaseurl(url);
     } else {
      url = origin + '/events-api/api/';
      this.svc.getbaseurl(url);
    }

  }
}
